export default {
  summer: 'Sommer',
  fall: 'Høst',
  winter: 'Vinter',
  spring: 'Vår'
}
